import styled from 'styled-components'
import { colours } from '@qflow/theme'

export const AlertRuleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 3.25rem;
`

export const TextArea = styled.div`
  min-width: 270px;
  max-width: 270px;
`
export const SettingArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 0.5rem;
  width: 100%;
`
export const Description = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
`
export const AdditionalText = styled.div`
  font-size: 0.75rem;
  font-weight: 400;
  color: ${colours.MID_GREY};
  line-height: 1rem;
  margin-top: 0.5rem;
`
export const RecipientsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`
export const AdditionalTextAddendum = styled.div`
  font-size: 0.65rem;
  font-style: italic;
  color: ${colours.MID_GREY};
  margin-top: 0.5rem;
`
